import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../secret/secret";
import { doc, getDoc, getFirestore, setDoc, updateDoc, where, writeBatch } from "firebase/firestore";
import { collection, getDocs } from "firebase/firestore";
import { query, orderBy } from "firebase/firestore";

import { createUserWithEmailAndPassword, getAuth, GoogleAuthProvider, onAuthStateChanged, sendEmailVerification, signInWithEmailAndPassword, signInWithPopup, signOut } from "firebase/auth";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { UserType } from "../../types/user-types";

import { getDownloadURL, getStorage, ref, uploadBytes, uploadBytesResumable } from "firebase/storage";
import { generalAPI } from "./firebase-api";
import { getBlobImg } from "../../utils/documents/documents-util";
import { ResultCodesEnum } from "../api-laravel";
import { getFirebaseError } from "../../utils/auth/auth-util";
import { ClientMJStatusType } from "../../redux/reducers/auth/auth-reducer";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional



//todo

//сделать enum с названиями коллекций
//TS must be here
type FirebaseAuthError = {
  code: 'auth/email-already-in-use' | 'auth/claims-too-large' | string | null

}

export type ResultResponseType = {
  resultCode: ResultCodesEnum
  data: null | { user: UserType }
  message: null | string
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const functions = getFunctions(app);
export const firestore = getFirestore(app);




export const authFirebaseAPI = {


  getAuth: async () => {

    const auth = getAuth(app);
    // let user = auth.currentUser;
    return auth

  },


  signIn: async (email: string, password: string) => {

    const auth = getAuth(app);
    let searchingUser = null
    try {

      let userCredential = await signInWithEmailAndPassword(auth, email, password)
      const user = userCredential.user;

      if (user && user.uid) {

        searchingUser = await generalAPI.getDoc('users', 'userId', user.uid)

      }

      console.log('login')
      console.log(searchingUser)
      return searchingUser
    } catch (error) {
      console.log(error)
      return null
    }
  },


  async signUp(
    name: string,
    surname: string,
    email: string,
    password: string,
    phone: string,
    documentType: string,
    documentNumber: string,
    birthday: string,
    clientStatus: ClientMJStatusType,
    documentPhoto1: string,
    documentPhoto2: string,
    signature: string
  ) {

    let auth = getAuth();
    let result = {
      resultCode: ResultCodesEnum.Error,
      data: null,
      message: 'Something Wrong with Registration Data'
    } as ResultResponseType
    // TODO if user
    // const user = auth.currentUser;


    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password)
      const user = userCredential.user;


      if (user) {
        const userId = user.uid;

        try {
          const setClient = httpsCallable(functions, 'setClient');
          const sendNewClientForAdmin = httpsCallable(functions, 'sendNewClientEmail');

          const sendNewClientEmailHTMLTEST = httpsCallable(functions, 'sendNewClientEmailHTMLTEST');

          let createdUser = {
            id: userId,
            userId,
            role: "client",
            email,
            isEmailVerified: false,
            name: name,
            surname: surname



          } as UserType


          let user = await generalAPI.setDoc('users', createdUser)
          let client = await setClient({
            userId,
            name,
            surname,
            email,
            phone,
            documentType,
            documentNumber,
            birthday,
            mjStatus: clientStatus,
            documents: {
              first: null,
              second: null,
              signature: null
            },
            status: "inProgress",
          })


          let withUserAuth = getAuth();
          let documents = await this.setDocumentPhoto(userId, documentPhoto1, documentPhoto2, signature)

          auth = getAuth();
          await signInWithEmailAndPassword(auth, email, password)

          if (documents) {
            const queryGet = query(collection(db, "clients"), where("userId", "==", userId));
            const querySnapshot = await getDocs(queryGet);
            let searchingClient

            querySnapshot.forEach((client) => {

              if (client.data().userId === userId) {
                searchingClient = doc(db, "clients", client.id);
              }

            });
            if (searchingClient) {

              await updateDoc(searchingClient, {
                documents: {
                  first: documents.first,
                  second: documents.second,
                  signature: documents.signature

                }
              });
              let updatedClient = await generalAPI.getDoc('clients', 'userId', userId)
              let fetchedEmail = await generalAPI.getDoc('emails', 'name', 'admin')
              // @ts-ignore
              let adminEmail = 'egktnt@gmail.com' 
              // let adminEmail = 'laravelsamvel@gmail.com' 
              // (fetchedEmail && fetchedEmail.value)  || 'laravelsamvel@gmail.com'
              // (fetchedEmail && fetchedEmail.value) || 'laravelsamvel@gmail.com'
              // let email = await sendNewClientForAdmin({ client: updatedClient, to: adminEmail })
              let email = await sendNewClientEmailHTMLTEST({ client: updatedClient, to: adminEmail })


              console.log(email)
              auth = getAuth()
              if (auth && auth.currentUser) {
                await sendEmailVerification(auth.currentUser)
              }
            }
            result = {
              resultCode: ResultCodesEnum.Success,
              data: {
                user: createdUser
              },
              message: null
            }
            return result

          }
          return result

        } catch (error) {
          if (typeof error === 'object' && error !== null) {

            const firebaseError = error as FirebaseAuthError;
            if (firebaseError.code) {
              result = getFirebaseError(firebaseError)
            }
          }

          return result
        }

      } else {
        return result
      }

    } catch (error: unknown) {
      if (typeof error === 'object' && error !== null) {
        const firebaseError = error as FirebaseAuthError;


        if (firebaseError.code) {

          result = getFirebaseError(firebaseError)
        }
      }
      return result
    }
  },


  setDocumentPhoto: async (userId: string, docFirst: any, docSecond: any, signature: any) => {
    // Get a reference to the storage service, which is used to create references in your storage bucket
    const storage = getStorage();
    const formData = new FormData();

    const result = {
      first: null as string | null,
      second: null as string | null,
      signature: null as string | null
    }

    // Добавляем остальные поля
    if (userId) {
      formData.append('first', docFirst);
      formData.append('second', docSecond);


      const first = formData.get('first')
      const second = formData.get('second')

      // Create a storage reference from our storage service


      try {

        if (docFirst) {
          const documentFirstRef = ref(storage, `/documents/${userId}/first`);
          // @ts-ignore
          await uploadBytesResumable(documentFirstRef, first)
          result.first = await getDownloadURL(documentFirstRef)
        }
        if (docSecond) {
          const documentSecondRef = ref(storage, `/documents/${userId}/second`);
          // @ts-ignore
          await uploadBytesResumable(documentSecondRef, second)
          result.second = await getDownloadURL(documentSecondRef)
        }
        if (signature) {
          const signatureBlob = await getBlobImg(signature)
          const signatureRef = ref(storage, `/documents/${userId}/signature`);
          await uploadBytesResumable(signatureRef, signatureBlob)
          result.signature = await getDownloadURL(signatureRef)
        }




        return result





      } catch (error) {
        return null;
      }

    }

    return null


  },

  signOut: async () => {
    const auth = getAuth(app);
    await signOut(auth)
  },


  getDocumentPhoto: async (userId: string, fileName: string) => {
    // Get a reference to the storage service, which is used to create references in your storage bucket
    // const storage = getStorage();

    // // Create a storage reference from our storage service
    // const fileRef = ref(storage, ` /documents/${userId}/${fileName}`);

    // // Create a reference to 'mountains.jpg'
    // const mountainsRef = ref(storage, 'mountains.jpg');

    // // Create a reference to 'images/mountains.jpg'
    // const mountainImagesRef = ref(storage, 'images/mountains.jpg');

    // // While the file names are the same, the references point to different files
    // fileRef.name === mountainImagesRef.name;           // true
    // fileRef.fullPath === mountainImagesRef.fullPath;   // false

    // uploadBytes(fileRef, file).then((snapshot) => {
    //   console.log('Uploaded a blob or file!');
    // });


    return null;
  }
}
